import CustomHelmet from '../CustomHelmet';
import { Button, Box, Typography, Grid, FormControl } from '@mui/material';
import { Link } from 'react-router-dom';
import { BASE_TITLE } from '../Common';
import inventoryModules, { aiDialogFeature } from '../ListGroups/AiInventoryErp';
import AiServiceSection from './AiServiceSection';
import AiDialogSection from './AiDialogSection';
import { categoryTabLinkSx, categoryTabTitleSx, categoryTabDescSx } from '../designTokens';
import { aiInventorySeo } from '../seoMeta';

const navItems = [
    ...inventoryModules.map((m) => ({ id: m.id, tag: m.tag, title: m.title })),
    { id: aiDialogFeature.id, tag: aiDialogFeature.tag, title: aiDialogFeature.title },
];

const AiInventoryErpIndex = () => {
    return (
        <>
            <CustomHelmet
                title={BASE_TITLE + 'AI 進銷存管理系統'}
                description={aiInventorySeo.description}
                keywords={aiInventorySeo.keywords}
            />
            <FormControl component="article" fullWidth>
                <Typography
                    sx={{
                        fontWeight: 700,
                        color: '#03363D',
                        mb: 2,
                        fontSize: '1.25rem',
                    }}
                >
                    核心模組架構
                </Typography>

                <Grid container spacing={2} sx={{ mb: { xs: 4, md: 5 } }}>
                    {navItems.map((item, index) => (
                        <Grid item xs={12} sm={6} md={3} key={item.id}>
                            <Box component="a" href={`#${item.id}`} sx={categoryTabLinkSx}>
                                <Typography className="category-tab-title" sx={categoryTabTitleSx}>
                                    {index + 1}. {item.tag}
                                </Typography>
                                <Typography variant="body2" className="category-tab-desc" sx={categoryTabDescSx}>
                                    {item.title}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>

                {inventoryModules.map((module, index) => (
                    <AiServiceSection
                        key={module.id}
                        product={module}
                        index={index}
                        reverse={index % 2 === 1}
                    />
                ))}

                <AiDialogSection
                    feature={aiDialogFeature}
                    index={inventoryModules.length}
                    reverse={inventoryModules.length % 2 === 1}
                />

                <Box
                    sx={{
                        mt: 2,
                        p: { xs: 3, md: 4 },
                        textAlign: 'center',
                        borderRadius: '12px',
                        backgroundColor: '#F5FCFC',
                        border: '1px solid #DAEDED',
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#03363D', mb: 1 }}>
                        想導入智慧進銷存與 AI 對話查詢？
                    </Typography>
                    <Typography sx={{ color: 'text.secondary', mb: 3, maxWidth: 560, mx: 'auto' }}>
                        歡迎與我們聯繫，由顧問為您說明模組規劃與導入流程。
                    </Typography>
                    <Button
                        component={Link}
                        to="/contactus"
                        state={{ anchor: 'default' }}
                        size="large"
                        variant="contained"
                        color="primary"
                        sx={{ fontSize: '16px', px: 4 }}
                    >
                        洽詢 AI 進銷存管理系統
                    </Button>
                </Box>
            </FormControl>
        </>
    );
};

export default AiInventoryErpIndex;
